var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-medium text-gray-900 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer",class:{'!font-bold text-primary': _vm.isActive(_vm.$attrs.code)},attrs:{"role":"menuitem","tabindex":"-1","id":"menu-item-0"},on:{"click":function($event){return _vm.changeSort(_vm.$attrs.code)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }